import { STUDIO_ROUTE_REGISTRY } from '@/config/studioRoutes'

// Sports Search's route ids, paths and URL identifiers. No React, context or
// API imports: App.jsx imports this eagerly for the legacy redirects, and
// sportsSearchErrors.js (which test API mocks load) imports it too.

// Route registry ids of the pages Sports Search links to.
export const OVERVIEW_ROUTE = 'sports-overview'
export const LAB_ROUTE = 'sports-search-lab'
export const RULES_ROUTE = 'sports-settings'
export const FILTERS_ROUTE = 'sports-filters'
export const DATA_ROUTE = 'sports-data'

// Overview's integration drawer is open while `?panel=integration` is set.
export const PANEL_PARAM = 'panel'
export const INTEGRATION_PANEL = 'integration'
// Search Lab's open tab is `?tab=`; old `/quality` links open Artifact check.
export const TAB_PARAM = 'tab'
export const ARTIFACT_CHECK_TAB = 'artifact-check'

/** The registry entry of a route id, or null. */
export function routeEntry(id) {
  return STUDIO_ROUTE_REGISTRY.find((entry) => entry.id === id) || null
}

/** The registry path of a route id (no access check). */
export function routePath(id) {
  const entry = routeEntry(id)
  if (!entry) throw new Error(`Unknown Studio route: ${id}`)
  return entry.path
}

export const OVERVIEW_PATH = routePath(OVERVIEW_ROUTE)
export const LAB_PATH = routePath(LAB_ROUTE)

/** `path?key=value`, leaving out empty values. */
export function withParams(path, params) {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value) search.set(key, value)
  }
  const query = search.toString()
  return query ? `${path}?${query}` : path
}
